/**
 * Zrušení select2 instancí, které po překreslení snippetu zůstaly odpojené od dokumentu.
 *
 * Nette po AJAXu nahradí obsah snippetu novým HTML (`$el.html(html)`). jQuery při tom volá
 * `cleanData()`, které uklidí `.data()` — a s ním i widgety, co se na jQuery data spoléhají
 * (bootstrap tooltip, jQuery UI sortable; to se navíc na `cleanData` přímo napojuje).
 * select2 4.0.10 je ale drží v modulové `Utils.__cache`, kterou `cleanData` nezná a
 * vyprazdňuje ji výhradně `destroy()`. Odpojené instance tak zůstávaly viset natrvalo a
 * přes `$element` držely celý odpojený strom snippetu včetně `<option>` seznamů. V editoru
 * jídelníčku, kde se po každém výběru z roletky překresluje celý týden, to znamenalo stovky
 * MB za jedno sezení a postupné tuhnutí až k pádu záložky.
 *
 * Ruší se tu proto výhradně select2 — sortable ani tooltip sahat netřeba a je to i škodlivé:
 * jQuery je zlikvidoval už při výměně, takže `sortable('destroy')` skončí výjimkou
 * „cannot call methods on sortable prior to initialization".
 *
 * Tohle je protipól inicializace v `5_handlers.js` ($(document).ajaxComplete → select2 nad
 * nově vykresleným DOMem).
 *
 * Prvky si zapamatujeme v `snippets.before()` (fire těsně před `applySnippet()`) a rušíme až
 * v `snippets.after()`, a to jen ty, které mezitím z dokumentu opravdu zmizely. Rozhodovat
 * se podle skutečného stavu je nutné, protože `applySnippet()` výměnu za určitých podmínek
 * přeskočí (shodné HTML bez skriptu, `data-ajax-append`) — teardown napevno v `before` by
 * v takovém případě zlikvidoval widgety, které na stránce zůstávají. Tenhle tvar se navíc
 * neváže na vnitřní podmínku nette.ajax, takže ho její případná změna nerozbije.
 */
(function () {
    var select2Utils;
    var select2UtilsResolved = false;

    /**
     * select2 vystavuje svůj AMD registr jako vlastnost funkce `$.fn.select2`. Kdokoli, kdo
     * tu funkci obalí (typicky instrumentace v testech), tím vlastnost shodí — referenci si
     * proto bereme jednou a držíme si ji.
     */
    function getSelect2Utils() {
        if (select2UtilsResolved) {
            return select2Utils;
        }
        select2UtilsResolved = true;
        try {
            select2Utils = ($.fn.select2 && $.fn.select2.amd)
                ? $.fn.select2.amd.require('select2/utils')
                : null;
        } catch (e) {
            select2Utils = null; // select2 na téhle stránce není
        }
        return select2Utils;
    }

    function detachedOnly($elements) {
        return $elements.filter(function () {
            return this.nodeType === 1 && !(this.isConnected !== undefined
                ? this.isConnected
                : document.contains(this));
        });
    }

    /**
     * `Select2.prototype.destroy()` maže cache jen pro `<select>`, ne pro svůj kontejner
     * (opraveno až ve 4.1). Osiřelý záznam kontejneru drží pod klíčem `element` odkaz zpátky
     * na `<select>`, takže by se strom neuvolnil ani po jinak korektním destroy. Stejně tak
     * zůstávají záznamy u `<option>`, kterým select2 spočítal data.
     */
    function removeSelect2Data($elements) {
        var utils = getSelect2Utils();
        if (!utils || !utils.RemoveData) {
            return;
        }
        $elements.each(function () {
            utils.RemoveData(this);
        });
    }

    /**
     * Vrátí DOM prvek, ke kterému se záznam v `Utils.__cache` váže, nebo `null`, když to
     * z jeho obsahu poznat nejde. Tvary záznamů odpovídají tomu, co select2 ukládá:
     * `{select2: instance}` u `<select>`, `{element: $select}` u kontejneru a `{data: …}`
     * u vykreslených položek rozbalené nabídky.
     */
    function cacheEntryNode(entry) {
        if (!entry || typeof entry !== 'object') {
            return null;
        }
        var candidate = null;
        if (entry.element) {
            candidate = entry.element;
        } else if (entry.select2 && entry.select2.$element) {
            candidate = entry.select2.$element;
        } else if (entry.data && entry.data.element) {
            candidate = entry.data.element;
        }
        if (!candidate) {
            return null;
        }
        var node = candidate.jquery ? candidate[0] : candidate;
        return (node && node.nodeType === 1) ? node : null;
    }

    /**
     * Rozbalení roletky vykreslí každou položku jako `<li>` a ke každé si select2 uloží
     * `Utils.StoreData(option, 'data', …)`. `Results.prototype.destroy()` je přitom pouhé
     * `this.$results.remove()` — cache po sobě neuklidí ani při korektním zrušení instance.
     * Uložená data drží v `element` odkaz zpátky na původní `<option>`, takže JEDINÝ takový
     * záznam udrží celý odpojený strom snippetu. Bez tohohle průchodu by tedy únik přetrval
     * všude, kde uživatel roletku skutečně rozbalí — a to je přesně běžná práce v editoru
     * jídelníčku.
     */
    function purgeDetachedCacheEntries() {
        var utils = getSelect2Utils();
        if (!utils || !utils.__cache) {
            return;
        }
        var cache = utils.__cache;
        for (var id in cache) {
            if (!Object.prototype.hasOwnProperty.call(cache, id)) {
                continue;
            }
            var node = cacheEntryNode(cache[id]);
            if (node && !(node.isConnected !== undefined ? node.isConnected : document.contains(node))) {
                delete cache[id];
            }
        }
    }

    $(function () {
        getSelect2Utils(); // vyzvednout referenci dřív, než ji cokoli může obalit

        if (!$.nette || !$.nette.ext) {
            return;
        }

        var snippets = $.nette.ext('snippets');
        if (!snippets || !snippets.before || !snippets.after) {
            return;
        }

        // `updateSnippets()` zpracovává snippety jeden po druhém a synchronně
        // (before → applySnippet → after), takže jedna proměnná stačí.
        var captured = null;

        snippets.before(function ($el) {
            captured = ($el && $el.length && $.fn.select2)
                ? {
                    instances: $el.find('.select2-hidden-accessible'),
                    data: $el.find('[data-select2-id]')
                }
                : null;
        });

        snippets.after(function () {
            var widgets = captured;
            captured = null;
            if (!widgets) {
                return;
            }

            // Úklid paměti nesmí za žádných okolností shodit zpracování snippetů — výjimka
            // odsud by přerušila `afterQueue.fire()` a zbytek odpovědi by se vůbec nepoužil
            // (typicky by zůstal viset otevřený modál).
            try {
                detachedOnly(widgets.instances).select2('destroy');
                removeSelect2Data(detachedOnly(widgets.data));
                purgeDetachedCacheEntries();
            } catch (e) {
                if (window.console && console.warn) {
                    console.warn('Úklid select2 po překreslení snippetu selhal:', e);
                }
            }
        });
    });
})();
